<template>
  <div :class="['a-input-text', 'a-input-text-div__' + name]">
    <label v-if="labelText !== ''" :class="['a-input-text__label', name + '-label']" :for="name">{{ labelText }}</label>
    <input
      class="a-input-text__input"
      :class="{'a-input--danger' : errorMessage !== '',  'a-input--success' : successState}"
      :type="type"
      :id="name"
      :name="name"
      :ref="name"
      :autocomplete="autocomplete"
      :maxlength="maxlength"
      :minlength="minlength"
      :value="value"
      :labelText="labelText"
      :placeholder="placeholder"
      :disabled="disabled"
      :required="required"
      :aria-required="required"
      @change="$emit('change', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      @keyup="$emit('keyup', $event)"
      @keypress="$emit('keypress', $event)"
    />
    <!-- Error message to go in here -->
    <p v-if="errorMessage !== ''" class="a-input__error-message">{{ errorMessage }}</p>
  </div>
</template>

<script type="ts">

export default {
  name: 'InputText',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    name: {
      type: String,
      default: ''
    },
    autocomplete: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    minlength: {
      type: Number,
      default: 0
    },
    maxlength: {
      type: Number,
      default: 255
    },
    value: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    labelText: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: ''
    },
    successState: {
      type: Boolean,
      default: false
    }
  },
  inject: ["parentValidator"],
  created () {
    this.$validator = this.parentValidator
  }
}
</script>


// WEBPACK FOOTER //
// InputText.vue?3910caaa